<template>
  <div class="dashboard">
    <img alt="Jienergi logo" src="../assets/Logo.svg" class="logo">
    <SerialInput/>

  </div>
</template>

<script>
import SerialInput from './SerialInput.vue';
export default {
  name: 'Dashboard',
  components: {
    SerialInput,
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h4 {
  margin: 40px 0 0;
  color: #aaaaaa;
}
</style>
